import { useNavigate } from "react-router-dom";
import Cookie from "cookie-universal";
import { useState } from "react";
import { authAxios } from "../Axios/createAxios";
export default function DeleteUser({ id, currentPassword }) {
  const navigate = useNavigate();
  const cookie = Cookie();
  const [sure, setSure] = useState(false);
  async function deleteUser() {
    try {
      const response = await authAxios.delete(`/users/${id}`, {
        data: { current_password: currentPassword },
      });
      console.log(response);
      navigate("/");
      cookie.remove("bearer");
    } catch (err) {
      console.log(err);
    }
  }
  return (
    <>
      <button type="button" onClick={() => setSure(true)}>
        Delete Account
      </button>
      {sure && (
        <div>
          <p>Are you sure you want to delete your account?</p>
          <button className="succ-c" type="button" onClick={() => setSure(false)}>
            No, go back
          </button>
          <button className="block mt-10 text-size-80" type="button" onClick={deleteUser}>
            Yes, delete it
          </button>
        </div>
      )}
    </>
  );
}
